module.exports = __webpack_public_path__ + "static/media/Etiquetas3.66d89882.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas3.png
// module id = 2256
// module chunks = 0